// runs on setup
export default function (fps: number) {
  let then = Date.now()

  const fpsInterval = 1000 / fps

  // runs every animation frame
  return function () {
    const now = Date.now()
    const elapsed = now - then

    if (elapsed > fpsInterval) {
      then = now - (elapsed % fps)
      return true
    }
    return false
  }
}
